import React from "react";
import MasterLayout from "../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../components/Breadcrumb";
import CancellationPolicy from "./CancellationPolicy";

const CancellatonPolicyLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Cancellaton Policy" />
      <CancellationPolicy />
    </MasterLayout>
  );
};

export default CancellatonPolicyLayout;
